// src/components/services/TraditionalSweets.jsx
import ServicePage from "../Common/ServicePage";

// Traditional Sweets specific services
const traditionalSweetsServices = [
  { 
    id: 1, 
    name: 'Gulab Jamun Box', 
    provider: 'Mithai Mahal', 
    image: 'https://placehold.co/600x400?text=Gulab+Jamun', 
    rating: 4.92, 
    reviews: 1200, 
    price: 299, 
    category: 'Milk Sweets' 
  },
  { 
    id: 2, 
    name: 'Rasgulla Platter', 
    provider: 'Bengali Sweets', 
    image: 'https://placehold.co/600x400?text=Rasgulla', 
    rating: 4.88, 
    reviews: 950, 
    price: 349, 
    category: 'Milk Sweets' 
  },
  { 
    id: 3, 
    name: 'Ladoo Assortment', 
    provider: 'Traditional Mithai', 
    image: 'https://placehold.co/600x400?text=Ladoo', 
    rating: 4.85, 
    reviews: 800, 
    price: 279, 
    category: 'Flour Sweets' 
  },
  { 
    id: 4, 
    name: 'Jalebi Pack', 
    provider: 'North Indian Specials', 
    image: 'https://placehold.co/600x400?text=Jalebi', 
    rating: 4.79, 
    reviews: 650, 
    price: 199, 
    category: 'Fried Sweets' 
  },
  { 
    id: 5, 
    name: 'Barfi Selection', 
    provider: 'Royal Sweets', 
    image: 'https://placehold.co/600x400?text=Barfi', 
    rating: 4.90, 
    reviews: 1100, 
    price: 329, 
    category: 'Milk Sweets' 
  },
  { 
    id: 6, 
    name: 'Mysore Pak', 
    provider: 'South Indian Specials', 
    image: 'https://placehold.co/600x400?text=Mysore+Pak', 
    rating: 4.86, 
    reviews: 500, 
    price: 249, 
    category: 'Gram Flour Sweets' 
  },
  { 
    id: 7, 
    name: 'Rasmalai', 
    provider: 'Bengali Specials', 
    image: 'https://placehold.co/600x400?text=Rasmalai', 
    rating: 4.91, 
    reviews: 700, 
    price: 379, 
    category: 'Milk Sweets' 
  },
  { 
    id: 8, 
    name: 'Kaju Katli', 
    provider: 'Dry Fruit Mithai', 
    image: 'https://placehold.co/600x400?text=Kaju+Katli', 
    rating: 4.94, 
    reviews: 900, 
    price: 499, 
    category: 'Dry Fruit Sweets' 
  },
  { 
    id: 9, 
    name: 'Peda Box', 
    provider: 'Mathura Specials', 
    image: 'https://placehold.co/600x400?text=Peda', 
    rating: 4.83, 
    reviews: 600, 
    price: 269, 
    category: 'Milk Sweets' 
  },
  { 
    id: 10, 
    name: 'Soan Papdi', 
    provider: 'Flaky Sweets', 
    image: 'https://placehold.co/600x400?text=Soan+Papdi', 
    rating: 4.77, 
    reviews: 450, 
    price: 189, 
    category: 'Flour Sweets' 
  },
  { 
    id: 11, 
    name: 'Halwa Variety', 
    provider: 'Halwa Specials', 
    image: 'https://placehold.co/600x400?text=Halwa', 
    rating: 4.82, 
    reviews: 550, 
    price: 299, 
    category: 'Halwa' 
  },
  { 
    id: 12, 
    name: 'Besan Ladoo', 
    provider: 'Traditional Specials', 
    image: 'https://placehold.co/600x400?text=Besan+Ladoo', 
    rating: 4.80, 
    reviews: 480, 
    price: 229, 
    category: 'Gram Flour Sweets' 
  }
];

const traditionalSweetsCategories = ['Milk Sweets', 'Flour Sweets', 'Fried Sweets', 'Gram Flour Sweets', 'Dry Fruit Sweets', 'Halwa', 'Festive Specials'];

const packages = [
  { id: 1, title: "Milk Sweets Combo", rating: "4.90 (1,000 reviews)", price: 599, originalPrice: 749, icon: "🥛" },
  { id: 2, title: "Dry Fruit Sweets Box", rating: "4.95 (800 reviews)", price: 899, originalPrice: 1099, icon: "🌰" },
  { id: 3, title: "Festival Sweet Hamper", rating: "4.87 (700 reviews)", price: 799, originalPrice: 999, icon: "🎁" },
];

const miniServices = [
  { id: 101, title: "Custom Sweet Box", price: 349, icon: "🎯" },
  { id: 102, title: "Sugar-Free Options", price: 449, icon: "🚫" },
  { id: 103, title: "Gift Packaging", price: 99, icon: "🎀" },
];

export default function TraditionalSweets() {
  return (
    <ServicePage
      serviceName="traditional-sweets"
      packages={packages}
      miniServices={miniServices}
      customServices={traditionalSweetsServices}
      customCategories={traditionalSweetsCategories}
      isCustomService={true}
    />
  );
}